import { gql, useMutation } from '@apollo/client';
import { useAuth } from '../auth/useAuth';
import { useLogger } from '@amzn/xb-hooks';
import { REQUEST_SELF_ORG_JOIN_ERROR } from '../../common/rumMetrics';

export const REQUEST_SELF_ORG_JOIN = gql`
    mutation requestSelfOrgJoin($learningActivityId: ID!, $organizationId: ID!, $userId: ID!) {
        requestSelfOrgJoin(learningActivityId: $learningActivityId, organizationId: $organizationId, userId: $userId) {
            id
            status
            statusReason
        }
    }
`;

export const useRequestSelfOrgJoin = (learningActivityId: string, organizationId: string) => {
    const { log, count } = useLogger();
    const { user } = useAuth();
    return useMutation(REQUEST_SELF_ORG_JOIN, {
        variables: {
            userId: user.id,
            learningActivityId: learningActivityId,
            organizationId: organizationId,
        },
        onError: (error) => {
            log.error('Error requesting self org join', error);
            count(REQUEST_SELF_ORG_JOIN_ERROR);
        },
    });
};
